import { InjectionToken } from '@angular/core';
import { IDocumentTypesDto } from 'app/main/pages/documents/dto/document-listing.dto';
import { IBox, IField } from 'app/main/pages/settings/documenttype/document-type-settings-modal/document-type-settings.dto';
import { HttpActionState } from 'app/main/pages/users/userslisting/store/users-listing.reducers';
import { Observable } from 'rxjs';
import { IEconomicChart } from '../../contract-control-economics-graph/contract-control-economics.dto';
import { GetRelatedContract, IDocument, IRevenueDTO } from '../../contract-control.dto';
import { IAddMultisectionForm, IGetContractById, ITotals } from '../../contract-control.service';
import { IPeriodRenewal, IProgressablePeriodRenewal } from '../../store/dto/contract-control-view';
import { ManagerDTO } from '../../store/dto/manager-list.dto';
import { ICostForm } from '../cc-cost/cost.dto';
import { ICustomBoxFormData } from '../cc-custom-box/cc-custom-box.component';
import { IOverviewFieldForm } from '../cc-overview/cc-overview.component';
import { IProgressBar } from '../cc-progress-bar/cc-progress-bar.component';
import { IRevenueForm } from '../cc-revenue/revenue.dto';
import { ISectionableRecipient } from 'app/main/pages/edit-template/edit-template.dto';
import { IMetadataItemDto } from 'app/main/pages/settings/documentfields/metadata-item.dto';

export interface IContractDetailFacade {
  readonly isLoadingContract$: Observable<boolean>;
  readonly selectedContract$: Observable<IGetContractById>;
  readonly selectedContractTotals$: Observable<ITotals>;
  readonly contractBoxes$: Observable<IBox[]>;
  readonly overviewCustomFields$: Observable<IField[]>;
  readonly selectedCategoryIds$: Observable<number[]>;
  readonly contractProgressBar$: Observable<IProgressBar | null>;
  readonly updateContractDataRequestState$: Observable<HttpActionState>;
  readonly updateCostRequestState$: Observable<HttpActionState>;
  readonly deleteCostRequestState$: Observable<HttpActionState>;
  readonly updateRevenueRequestState$: Observable<HttpActionState>;
  readonly deleteRevenueRequestState$: Observable<HttpActionState>;
  readonly selectedRevenue$: Observable<IRevenueDTO>;
  readonly fetchContractLayoutSettingsRequestState$: Observable<HttpActionState>;
  readonly contractLayoutSettings$: Observable<IDocumentTypesDto | null>;
  readonly contractEconomicsChartData$: Observable<IEconomicChart[]>;
  readonly fetchEconomicsChartState$: Observable<HttpActionState>;
  readonly managersList$: Observable<{ managers: ManagerDTO[] }>;
  readonly contacts$: Observable<ISectionableRecipient[]>
  readonly metaDataItems$: Observable<IMetadataItemDto[]>
  readonly relatedContracts$: Observable<GetRelatedContract[]>;
  readonly contractControlActivities$: Observable<any>;
  readonly contractControlNotes$: Observable<any>;
  readonly contractControlTodos$: Observable<any>;
  readonly contractControlDocuments$: Observable<any>;
  readonly updateLayoutSettingsRequestState$: Observable<boolean>;
  readonly loadingTodoIds$: Observable<number[]>;
  readonly fetchOverviewCustomFieldsRequestState$: Observable<boolean>;

  // Methods
  fetchContract(id: number): void;
  fetchContractBoxes(contract_control_id: number, document_type_id: number): void;
  fetchManagers(contract_control_id: number): void;
  removeManager(manager: ManagerDTO, index: number, contract_control_id: number): void;
  linkManager(formData: IAddMultisectionForm): void;

  fetchDocuments(contract_control_id: number): void;
  addDocument(formData: any): void;
  removeDocument(document: IDocument, index: number, contract_control_id: number): void;

  getContractControlActivities(contract_control_id: number): void;
  getContractControlNotes(contract_control_id: number): void;
  getContractControlTodos(contract_control_id: number): void;
  getContractControlDocuments(contract_control_id: number): void;

  updateContractData(column: string, value: string | number | number[]): void;
  updateCost(costForm: ICostForm): void;
  deleteCost(costId: number): void;

  updateRevenue(revenueForm: IRevenueForm): void;
  deleteRevenue(revenueId: number): void;
  editRevenue(revenue: IRevenueDTO): void;
  clearSelectedRevenue(): void;
  resetState(): void;

  resetConnectedContracts(): void;
  selectContract(contractId: number): void;

  updatePeriodRenewalProgress(periodRenewal: IPeriodRenewal | IProgressablePeriodRenewal): void;
  updatePeriodRenewal(periodRenewal: IPeriodRenewal | IProgressablePeriodRenewal): void;

  getEconomicsChartData(): void;
  updateCustomBoxValue(customBoxFormData: ICustomBoxFormData): void;
  getOverviewCustomFields(contract_control_id: number): void;

  updateOverviewCustomFieldValue(formData: IOverviewFieldForm): void;
  getContractProgressBar(contract_control_id: number): void;
  fetchRelatedContracts(contract_control_id: number): void;
  linkRelatedContract(formData: { contract_control_id: number; related_contract_id: number }, item: GetRelatedContract): void;
  unlinkRelatedContract(related_contract_id: number, contract_control_id: number): void;
  fetchContacts(contract_control_id: number): void;
  linkContact(formData: IAddMultisectionForm): void;
  unlinkContact(sectionable_id: number, contract_control_id: number): void;

  addFieldInCustomBox(box_id: number, field: IField): void;

  fetchMetaDataItems(): void;
  updateLayoutSettings(layoutSettings: IDocumentTypesDto, contract_control_id: number): void;
  setTodoLoading(todoId: number, isLoading: boolean): void;
  updateTodoStatus(todoId: number, newStatus: string, previousStatus: string)
}


export const CONTRACT_DETAIL_FACADE_TOKEN = new InjectionToken<IContractDetailFacade>(
  'Contract Detail Facade Token'
);
